import indigo from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';

export default {
    palette: {
        primary: {
            light: pink[300],
            main: pink[500],
            dark: pink[700],
            contrastText: '#fff'
        },
        secondary: {
            light: pink[300],
            main: pink['A200'],
            dark: pink[700],
            contrastText: '#fff'
        },
        tertiary: {
            light: green[300],
            main: green['A200'],
            dark: green[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange',
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
};
